/**
 * Preferencia de tema (claro/escuro) do painel.
 *
 * A chave NAO pode conter "muven-": o interceptor de autenticacao
 * (src/auth/interceptors/registerAuthInterceptor.ts) injeta como header HTTP toda chave
 * de localStorage que casa com /muven-/.
 *
 * O script inline de public/index.html le essa mesma chave antes do primeiro paint para
 * a tela ja nascer no tema certo. Mudou o nome ou os valores aqui? Mude la tambem.
 *
 * Nada limpa essa chave - o logout so remove `muven-client-id` -, entao a preferencia
 * e por navegador, nao por conta.
 */
const THEME_KEY = 'theme'

export const THEME_LIGHT = 'light'
export const THEME_DARK = 'dark'
export const THEMES = [THEME_LIGHT, THEME_DARK]

// O padrao e sempre claro; o tema do sistema operacional e ignorado de proposito,
// mesma decisao de produto do Bluve e do Moub.
function defaultTheme():string {
    return THEME_LIGHT
}

function isValid(theme:any):boolean {
    return THEMES.indexOf(theme) !== -1
}

export default {
    getTheme():string {
        try {
            const stored = localStorage.getItem(THEME_KEY)

            if (!isValid(stored)) {
                return defaultTheme()
            }

            return stored as string
        } catch (e) {
            // storage indisponivel (modo privado, storage bloqueado) nunca pode quebrar a tela
            return defaultTheme()
        }
    },
    setTheme(theme:string):void {
        if (!isValid(theme)) {
            return
        }

        try {
            localStorage.setItem(THEME_KEY, theme)
        } catch (e) {
            // sem persistencia o tema continua trocando, so nao lembra da escolha
        }
    },
}
